import { useTranslation } from "react-i18next";
import ClientSidebar from "../components/ClientSidebar";

export default function PerfilPagosPage() {
  const { t } = useTranslation("profile");

  return (
    <div className="min-h-screen bg-offwhite pt-14 md:pt-20 pb-12">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
            <ClientSidebar active="payments" />
            <div className="flex-1 min-w-0">
              <div className="bg-white rounded-2xl border border-gray-100 p-5 md:p-6">
                <h1 className="text-lg font-bold text-charcoal mb-4">{t("profile.paymentMethods")}</h1>

                <div className="flex items-start gap-4 p-4 bg-ocean/5 border border-ocean/15 rounded-xl">
                  <div className="w-10 h-10 shrink-0 flex items-center justify-center rounded-lg bg-white border border-ocean/20 text-ocean">
                    <i className="ri-shield-check-line text-xl" aria-hidden />
                  </div>
                  <div className="min-w-0">
                    <p className="text-sm font-semibold text-charcoal">{t("profile.paymentsSecureTitle")}</p>
                    <p className="text-sm text-gray-600 leading-relaxed mt-1">{t("profile.paymentsSecureBody")}</p>
                  </div>
                </div>

                <p className="text-xs text-gray-500 mt-4 px-1">{t("profile.paymentsMethodsNote")}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
